<template>
  <div>
    <template v-if="isArray">
      <div v-for="(item, idx) in value" :key="idx" class="ai-tree-item mb-1">
        <ai-answer-tree :value="item" />
        <hr v-if="idx < value.length - 1" class="my-1" />
      </div>
    </template>
    <template v-else-if="isObject">
      <dl class="row mb-0">
        <template v-for="(v, k) in value">
          <dt class="col-sm-5 font-weight-bold" :key="k + '-k'">
            {{ label(k) }}
          </dt>
          <dd class="col-sm-7" :key="k + '-v'">
            <ai-answer-tree v-if="isComplex(v)" :value="v" />
            <span v-else>{{ formatValue(v, k) }}</span>
          </dd>
        </template>
      </dl>
    </template>
    <template v-else>
      <span>{{ formatValue(value) }}</span>
    </template>
  </div>
</template>

<script>
import { aiFieldLabel, aiFormatValue } from "../constants/aiPreInterviewLabels";

/**
 * Renderiza recursivamente qualquer valor JSON (respostas da Pré-Entrevista por
 * IA) como listas/definições legíveis, com rótulos e valores em português.
 */
export default {
  name: "AiAnswerTree",
  props: {
    value: {
      default: null,
    },
  },
  computed: {
    isArray() {
      return Array.isArray(this.value);
    },
    isObject() {
      return (
        this.value !== null &&
        typeof this.value === "object" &&
        !Array.isArray(this.value)
      );
    },
  },
  methods: {
    isComplex(v) {
      return v !== null && typeof v === "object";
    },
    label(k) {
      return aiFieldLabel(k);
    },
    formatValue(v, k) {
      // rótulos de enum + R$ + datas dd/mm/aaaa centralizados no helper
      return aiFormatValue(k, v);
    },
  },
};
</script>
